"use client";

import {
  ptSerif_body_md_regular,
  ptSerif_body_md_bold,
} from "@frontend/design-system";
import styled, { css } from "styled-components";

export const DBDetailValueShell = styled.div<{
  $width?: string;
  $minWidth?: string;
  $maxWidth?: string;
  $justifyContent?: string;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  flex: 1;
  color: var(--Color-Common-Text-Primary, #2a2f37);
  ${ptSerif_body_md_regular}
  background: var(--NEURAL-Gray-010, #fff);
  padding: 0.8rem;
  white-space: pre-wrap;
  border-right: 1px solid var(--Color-Common-Border-Tertiary, #e5e7eb);

  ${({ $justifyContent }) =>
    $justifyContent &&
    css`
      justify-content: ${$justifyContent};
    `};

  ${({ $width }) =>
    $width &&
    css`
      width: ${$width};
      max-width: ${$width};
    `};

  ${({ $minWidth }) =>
    $minWidth &&
    css`
      min-width: ${$minWidth};
    `}

  ${({ $maxWidth }) =>
    $maxWidth &&
    css`
      max-width: ${$maxWidth};
    `}

  i {
    ${ptSerif_body_md_regular}
  }

  b {
    ${ptSerif_body_md_bold}
  }

  img {
    width: auto;
    max-width: 100%;
    height: auto;
  }

  sup {
    vertical-align: super;
    font-size: 1rem;
  }

  sub {
    vertical-align: sub;
    font-size: 1rem;
  }
`;
